import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import api from '../api/client';

/**
 * Application Sidebar with navigation
 */
const Sidebar = ({ user, view, setView, selectedMeeting, setSelectedMeeting, onLogout }) => {
  const [myMeetings, setMyMeetings] = useState([]);

  useEffect(() => {
    loadMyMeetings();
  }, []);

  const loadMyMeetings = async () => {
    try {
      // Always fetch only the user's own meetings for the sidebar
      const data = await api.get('/meetings');
      setMyMeetings(data);
    } catch (error) {
      console.error('Failed to load meetings:', error);
    }
  };

  const handleMeetingClick = (meeting) => {
    setSelectedMeeting(meeting);
    setView('meeting-detail');
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        Meeting<span>Manager</span>
      </div>

      <div className="sidebar-nav">
        <div className="nav-section">
          <div className="nav-title">Main</div>
        <div
          className={`nav-item ${view === 'dashboard' ? 'active' : ''}`}
          onClick={() => setView('dashboard')}
        >
          My Dashboard
        </div>
        <div
          className={`nav-item ${view === 'my-todos' ? 'active' : ''}`}
          onClick={() => setView('my-todos')}
        >
          My Tasks
        </div>
        <div
          className={`nav-item ${view === 'my-profile' ? 'active' : ''}`}
          onClick={() => setView('my-profile')}
        >
          My Profile
        </div>
      </div>

      {user.isAdmin && (
        <div className="nav-section">
          <div className="nav-title">Admin</div>
          <div
            className={`nav-item ${view === 'users' ? 'active' : ''}`}
            onClick={() => setView('users')}
          >
            All Users
          </div>
          <div
            className={`nav-item ${view === 'meetings' ? 'active' : ''}`}
            onClick={() => setView('meetings')}
          >
            All Meetings
          </div>
          <div
            className={`nav-item ${view === 'all-todos' ? 'active' : ''}`}
            onClick={() => setView('all-todos')}
          >
            All Tasks
          </div>
          <div
            className={`nav-item ${view === 'all-topics' ? 'active' : ''}`}
            onClick={() => setView('all-topics')}
          >
            All Topics
          </div>
        </div>
      )}

      {user.isManager && !user.isAdmin && (
        <div className="nav-section">
          <div className="nav-title">Manager</div>
          <div
            className={`nav-item ${view === 'meetings' ? 'active' : ''}`}
            onClick={() => setView('meetings')}
          >
            All Meetings
          </div>
        </div>
      )}

      <div className="nav-section">
        <div className="nav-title">My Meetings</div>
        {myMeetings.length === 0 ? (
          <div className="nav-item text-muted">No meetings</div>
        ) : (
          myMeetings.map(meeting => (
            <div
              key={meeting.id}
              className={`nav-item ${view === 'meeting-detail' && selectedMeeting?.id === meeting.id ? 'active' : ''}`}
              onClick={() => handleMeetingClick(meeting)}
            >
              {meeting.name}
            </div>
          ))
        )}
      </div>
      </div>

      <div className="sidebar-footer">
        <div className="sidebar-user-name">{user.firstName} {user.lastName}</div>
        <div className="sidebar-user-role">{user.isAdmin ? 'Administrator' : user.isManager ? 'Manager' : 'Member'}</div>
        <button className="btn btn-secondary btn-small btn-full" onClick={onLogout}>
          Logout
        </button>
      </div>
    </aside>
  );
};

Sidebar.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    isManager: PropTypes.bool,
  }).isRequired,
  view: PropTypes.string.isRequired,
  setView: PropTypes.func.isRequired,
  selectedMeeting: PropTypes.object,
  setSelectedMeeting: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
};

export default Sidebar;
